module.exports = __webpack_public_path__ + "static/img/1.7e170bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/1.png
// module id = G/iC
// module chunks = 0